<div class="flight-location-wrapper" [ngClass]="{'departure' : isDeparture}">
    <ng-container *ngIf="isPrecise">
        <div *ngIf="!locationName" class="empty-state">
            <app-data-empty-animation height="28px" width="130px"></app-data-empty-animation>
        </div>
        <div *ngIf="locationName" class="location-name">{{locationName}}</div>
        <div class="location-label">{{locationLabel}}</div>
    </ng-container>

    <ng-container *ngIf="!isPrecise">
        <div class="icon-wrapper">
            <app-svg-loader *ngIf="generalIcon === 'beach'" [height]="getIconSize()" url="assets/svg/beach.svg"></app-svg-loader>
            <app-svg-loader *ngIf="generalIcon === 'mountain'" [height]="getIconSize()" url="assets/svg/mountain.svg"></app-svg-loader>
        </div>
        <div class="location-label">{{locationLabel}}</div>
    </ng-container>    
</div>
